import { Component } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';

@Component({
    selector: 'tt-tempstock',
    templateUrl: './tempstock.component.html',
    styleUrls: ['./tempstock.component.css'],
    standalone: false,
})
export class TempstockComponent {
    public grid: GridOptions = new Grid()
        .setRememberId('tempstockGrid')
        .setLoadDataFunction({ method: 3391, parameters: () => ({}) })
        .setConfig({ serverSideHandling: true })
        .setSpecialFunc({ newTab: true })
        .setKendoConfig({ height: null, selectable: false });
}
